module.exports = __webpack_public_path__ + "img/media_3.2c9119a6.png";